
import * as AppCommands from "@/assets/scripts/Application/Commands";
// Dependencies
import { Section, Property } from '@/assets/scripts/Page';
import { defineComponent, PropType } from 'vue';
// Components
import FieldGrid from "@/components/Controls/Fields/FieldGrid.vue";

export default defineComponent({
  name: 'PageSection',
  props: {
    section: {
      type: Object as PropType<Section>,
      required: true
    }
  },
  computed: {

    /**
     * Returns the section's properties.
     * @returns
     *  The section's properties.
     */
    properties(): Property[] {
      return [...this.section.properties.values()]
    }

  },
  emits: ["execute"],
  mounted() {
    // Execute mount command
    let cmd = AppCommands.mountSection(this.section, this.$el);
    this.$emit("execute", cmd);
  },
  unmounted() {
    // Execute destroy command
    let cmd = AppCommands.destroySection(this.section);
    this.$emit("execute", cmd);
  },
  components: { FieldGrid }
});
